import './styles/main.css';
import './styles/editor.css';
import './styles/preview.css';
import { App } from './app';

// Initialize the application
const app = new App();
app.init().catch((error) => {
    console.error('Failed to initialize application:', error);
});
